import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Search } from 'lucide-react'

export interface MeetingsFiltersState {
  search: string
  type: string
  status: string
}

interface Props {
  value: MeetingsFiltersState
  onChange: (next: MeetingsFiltersState) => void
}

const MeetingFilterBar: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2 flex-wrap flex-1 min-w-0">
      <div className="relative">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder={t('Common_search')}
          value={value.search}
          onChange={(e) => onChange({ ...value, search: e.target.value })}
          className="h-8 w-[220px] pl-8 text-sm"
        />
      </div>

      <Select
        value={value.type}
        onValueChange={(v) => onChange({ ...value, type: v })}
      >
        <SelectTrigger className="h-8 w-[160px] text-sm">
          <SelectValue placeholder={t('Meeting_filter_type')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('Meeting_filter_type_all')}</SelectItem>
          <SelectItem value="PROGRESS">{t('Meeting_type_progress')}</SelectItem>
          <SelectItem value="SAFETY">{t('Meeting_type_safety')}</SelectItem>
          <SelectItem value="CLIENT">{t('Meeting_type_client')}</SelectItem>
          <SelectItem value="TECHNICAL">{t('Meeting_type_technical')}</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={value.status}
        onValueChange={(v) => onChange({ ...value, status: v })}
      >
        <SelectTrigger className="h-8 w-[160px] text-sm">
          <SelectValue placeholder={t('Meeting_filter_status')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('Meeting_filter_status_all')}</SelectItem>
          <SelectItem value="SCHEDULED">{t('Meeting_status_scheduled')}</SelectItem>
          <SelectItem value="IN_PROGRESS">{t('Meeting_status_in_progress')}</SelectItem>
          <SelectItem value="COMPLETED">{t('Meeting_status_completed')}</SelectItem>
          <SelectItem value="CANCELLED">{t('Meeting_status_cancelled')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default MeetingFilterBar
